<template>
  <div class="not-found-pages">
    <HeaderOperator />

    <div class="dashboard-shell operator-event-page">
      <section class="operator-event-shell glass-surface">
        <div class="operator-event-shell__copy">
          <small>Control de acceso</small>
          <h1 class="dashboard-title">{{ event.name || 'Control de accesos' }}</h1>
          <p>Escanea tickets al ingreso. Si necesitas buscar por persona o codigo, cambia a manual.</p>
        </div>

        <div class="operator-event-shell__tabs" role="tablist" aria-label="Modo de acceso">
          <button
            v-for="tab in operatorTabs"
            :key="tab.key"
            :class="['operator-event-shell__tab', { 'is-active': value === tab.key }]"
            type="button"
            role="tab"
            :aria-selected="value === tab.key"
            @click="value = tab.key"
          >
            <i :class="tab.icon"></i>
            <span>{{ tab.label }}</span>
          </button>
        </div>
      </section>

      <div v-if="showLoading" class="workspace-empty">Cargando control de accesos...</div>
      <QrReader v-show="value === 'qr'" v-if="!showLoading" :event="event" :show-header="false" />
      <AssistanceList v-show="value === 'manual'" v-if="!showLoading" :event="event" />
    </div>
  </div>
</template>

<script>
import { apiService } from '../../common/api.services.js'
import QrReader from '@/pages/operator/QrReader.vue'
import AssistanceList from './AssistanceList.vue'
import HeaderOperator from '../../components/HeaderOperator.vue'

export default {
  name: 'EventOperatorView',

  components: {
    QrReader,
    HeaderOperator,
    AssistanceList,
  },

  props: {
    slug: {
      required: true,
    },
  },

  data() {
    return {
      value: 'qr',
      event: {},
      showLoading: false,
      operatorTabs: [
        { key: 'qr', label: 'QR', icon: 'fas fa-qrcode' },
        { key: 'manual', label: 'Manual', icon: 'fas fa-keyboard' },
      ],
    }
  },

  created() {
    this.getEvent()
  },

  methods: {
    getEvent() {
      this.showLoading = true
      apiService(`/api/events-basic/${this.slug}/`).then((data) => {
        this.event = data
        this.showLoading = false
      })
    },
  },
}
</script>

<style scoped>
.operator-event-page {
  display: grid;
  gap: 16px;
}

.operator-event-shell {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding: clamp(18px, 3vw, 30px) !important;
  margin-bottom: 0;
  background:
    radial-gradient(circle at top left, rgba(214, 221, 232, 0.1), transparent 26%),
    radial-gradient(circle at top right, rgba(140, 243, 232, 0.12), transparent 22%),
    linear-gradient(180deg, rgba(11, 14, 23, 0.94), rgba(8, 10, 16, 0.9)) !important;
}

.operator-event-shell__copy {
  max-width: 780px;
  display: grid;
  gap: 10px;
}

.operator-event-shell__copy small {
  display: block;
  color: rgba(201, 214, 230, 0.68);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.operator-event-shell__copy .dashboard-title {
  font-family: 'Syne', 'Sora', sans-serif !important;
  font-size: clamp(1.65rem, 2.5vw, 2.75rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.04em;
}

.operator-event-shell__copy p {
  max-width: 620px;
  margin: 0;
  color: var(--text-soft);
  font-size: 0.96rem;
  line-height: 1.65;
}

.operator-event-shell__tabs {
  display: inline-flex;
  gap: 8px;
  width: auto;
  max-width: 100%;
  padding: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid rgba(194, 212, 224, 0.1);
}

.operator-event-shell__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--text-soft);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.operator-event-shell__tab.is-active {
  color: #081114;
  background: linear-gradient(135deg, rgba(243, 248, 251, 0.94), rgba(138, 223, 216, 0.9));
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
}

@media (max-width: 720px) {
  .operator-event-page {
    gap: 12px;
  }

  .operator-event-shell {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
    border-radius: 24px !important;
  }

  .operator-event-shell__copy {
    gap: 8px;
  }

  .operator-event-shell__copy .dashboard-title {
    font-size: clamp(1.8rem, 9vw, 2.65rem);
  }

  .operator-event-shell__copy p {
    font-size: 0.86rem;
    line-height: 1.5;
  }

  .operator-event-shell__tabs {
    width: 100%;
  }

  .operator-event-shell__tab {
    flex: 1;
    min-height: 40px;
  }
}
</style>
